import React from 'react';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';

export function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy" description="Chesapeake Counseling Center privacy policy and HIPAA notice summary." path="/privacy" />
      <PageHero eyebrow="Legal" title="Privacy Policy" crumbs={[{ label:'Home', to:'/' }, { label:'Privacy Policy' }]} />
      <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-5 text-[color:var(--taupe-gray)] leading-relaxed">
          <p>Chesapeake Counseling Center is committed to protecting your privacy. This policy describes what information we collect, how it is used, and the measures we take to protect it in compliance with HIPAA and applicable law.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">Information We Collect</h2>
          <p>We collect only the information necessary to provide clinical services, respond to inquiries, and comply with legal requirements. This may include name, contact information, and details you choose to share via our website forms.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">How We Use Your Information</h2>
          <p>Your information is used to schedule and coordinate care, respond to questions, and fulfill regulatory obligations. We do not sell your information to third parties.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">Your Rights</h2>
          <p>You have the right to access, correct, or request deletion of your personal information. Please contact our office to make such a request.</p>
          <p className="text-sm italic">This is a summary. Please contact our office for the full HIPAA Notice of Privacy Practices.</p>
        </div>
      </section>
    </>
  );
}

export function Terms() {
  return (
    <>
      <Seo title="Terms of Use" description="Terms of use for the Chesapeake Counseling Center website." path="/terms" />
      <PageHero eyebrow="Legal" title="Terms of Use" crumbs={[{ label:'Home', to:'/' }, { label:'Terms of Use' }]} />
      <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-5 text-[color:var(--taupe-gray)] leading-relaxed">
          <p>By accessing this website, you agree to these Terms of Use. This website is for informational purposes and does not constitute the practice of therapy or a therapist-client relationship.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">Not a Substitute for Care</h2>
          <p>Nothing on this website should be considered a substitute for professional mental health treatment. If you are experiencing a mental health emergency, please call 911 or the 988 Suicide & Crisis Lifeline.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">Content Ownership</h2>
          <p>All content, imagery, and design elements on this site are the property of Chesapeake Counseling Center or its licensors and may not be reproduced without permission.</p>
          <h2 className="font-serif-display text-2xl text-[color:var(--deep-sage)] pt-4">Changes</h2>
          <p>These terms may be updated periodically. Continued use of the site constitutes acceptance of any updates.</p>
        </div>
      </section>
    </>
  );
}
